import styles from './base-course-dialog.module.scss';
import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../requestUtils';
import { Col, Row } from 'reactstrap';
import { convertUnixTime } from '../course-admin/helpers';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Checkbox, CheckboxLabel, Chip, DatePicker, Dialog, DialogActions, DialogContent, DialogTitle, Divider, endOfDayAt4PM, Froala, GrayOutlinedButton, Icon, IconButton, Link, ListItemText, LoadingButton, MenuItem, MultiLineTextField, Select, SnackBarContext, startOfDayAt7AM, TextField, Typography } from '@frontend-workspace/react-shared-lib';
import { ICourseRegistrationCheckConflict } from '../_models/course-registration-check-conflict';
import { ICatalog } from '../_models/catalog';
import { IComputer } from '../_models/computer';
import { ICourse } from '../_models/course';
import { IEmailTemplateSurvey } from '../_models/email-template-survey';
import { IInstructor } from '../_models/instructor';
import { IPrice } from '../_models/price';
import { IRoom } from '../_models/room';
import { ISurveyTypes } from '../_models/survey-types';
import ConflictCheckDiaryDialog from '../course-admin/course/conflict-check-diary-dialog/conflict-check-diary-dialog';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface BaseCourseDialogProps {
  open: boolean;
  refreshData: () => void;
  onClose: () => void;
  course: ICourse;
  handleOkText: string;
  headerText: string;
}

export function BaseCourseDialog(props: BaseCourseDialogProps) {
  const course = props.course;
  const { data: catalogs }: { data: ICatalog[] } = useCourseGetRequestHook("catalog/getAll", []);
  const { data: instructors }: { data: IInstructor[] } = useCourseGetRequestHook("resource/instructors", []);
  const { data: rooms }: { data: IRoom[] } = useCourseGetRequestHook("room/getAll", []);
  const { data: emailTemplatesSurveys }: { data: IEmailTemplateSurvey[] } = useCourseGetRequestHook("settings/emailTemplates/surveys", []);
  const { data: computers }: { data: IComputer[] } = useCourseGetRequestHook("resource/computers", []);
  const { data: prices }: { data: IPrice[] } = useCourseGetRequestHook("resource/prices", []);
  const { data: emailTemplatesCourseConfirmation1 }: { data: IEmailTemplateSurvey } = useCourseGetRequestHook("settings/emailTemplates/courseConfirmation1", []);
  const { data: surveyTypes }: { data: ISurveyTypes[] } = useCourseGetRequestHook("catalog/surveyTypes", []);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const [adskCourseId, setAdskCourseId] = useState<string>('');
  const [catalogId, setCatalogId] = useState<string>('');
  const [date, setDate] = useState<Date | null>(null);
  const [instructorId, setInstructorId] = useState<string>('');
  const [assistantInstructorId, setAssistantInstructorId] = useState<string>('');
  const [trainingRoomId, setTrainingRoomId] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [surveyEmailTemplateId, setServeyEmailTemplateId] = useState<string>('');
  const [computerIds, setComputerIds] = useState<string[]>([]);
  const [canceled, setCanceled] = useState<boolean>(false);
  const [doNotPublish, setDoNotPublish] = useState<boolean>(false);
  const [isTotalPrice, setIsTotalPrice] = useState<boolean>(false);
  const [priceId, setPriceId] = useState<string>('');
  const [priceInfo, setPriceInfo] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [mobile, setMobile] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [company, setCompany] = useState<string>('');
  const [htmlContentIngress, setHtmlContentIngress] = useState<string>('');
  const [htmlContentDescription, setHtmlContentDescription] = useState<string>('');
  const [courseRegistrationInfo, setCourseRegistrationInfo] = useState<string>('');
  const [emailTemplateHtml, setEmailTemplateHtml] = useState<string>('');
  const [evaluationId, setEvaluationId] = useState<string>('');
  const [helperText, setHelperText] = useState<string>("");
  const [conflicts, setConflicts] = useState<string>('');
  const [isCheckingConflict, setIsCheckingConflict] = useState<boolean>(true);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleAdskCourseIdChange = (event: ChangeEvent<HTMLInputElement>) => setAdskCourseId(event.target.value);
  const handleCatalogIdChange = (id: string) => {
    setCatalogId(id);
    const catalog = catalogs.find(c => c.id === id);
    if (catalog) {
      setHtmlContentIngress(catalog?.courseIngress);
      setHtmlContentDescription(catalog?.courseDescription);
    }
  };

  const handleDateChange = (event: any) => {
    setDate(startOfDayAt7AM(event));
    const endDate = endOfDayAt4PM(event);

    if (course.duration.unit === 'dag' || course.duration.unit === 'dager') {
      endDate.setDate(endDate.getDate() + (course.duration.value) - 1);
    }
    setEndDate(endDate);
  }
  const handleInstructorIdChange = (id: string) => {
    setInstructorId(id);
  }
  const handleAssistantInstructorIdChange = (id: string) => {
    setAssistantInstructorId(id);
  }
  const handleTrainingRoomIdChange = (id: string) => {
    setTrainingRoomId(id);
  }
  const handleServeyEmailTemplateIdChange = (event: ChangeEvent<HTMLSelectElement>) => setServeyEmailTemplateId(event.target.value);
  const handleCanceled = (event: ChangeEvent<Element>, checked: boolean) => setCanceled(checked);
  const handleDoNotPublish = (event: ChangeEvent<Element>, checked: boolean) => setDoNotPublish(checked);
  const handleIsTotalPrice = (event: ChangeEvent<Element>, checked: boolean) => setIsTotalPrice(checked);
  const handlePriceIdChange = (event: ChangeEvent<HTMLSelectElement>) => setPriceId(event.target.value);
  const handlePriceInfoChange = (event: ChangeEvent<HTMLInputElement>) => setPriceInfo(event.target.value);
  const handleFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => setFirstName(event.target.value);
  const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>) => setLastName(event.target.value);
  const handleMobileChange = (event: ChangeEvent<HTMLInputElement>) => setMobile(event.target.value);
  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value);
  const handleCompanyChange = (event: ChangeEvent<HTMLInputElement>) => setCompany(event.target.value);
  const handleCourseRegistrationInfoChange = (event: ChangeEvent<HTMLInputElement>) => setCourseRegistrationInfo(event.target.value);
  const handleEvaluationIdChange = (event: ChangeEvent<HTMLSelectElement>) => setEvaluationId(event.target.value);

  const [isConflictOpen, setIsConflictOpen] = useState(false);
  const toggleConflictOpen = () => setIsConflictOpen(!isConflictOpen);

  useEffect(() => {
    if (course && emailTemplatesCourseConfirmation1) {
      setAdskCourseId(course.adskCourseId);
      setCatalogId(course.catalogId);
      setDate(new Date(course.date * 1000));
      setInstructorId(course.instructor?.id ?? "");
      setAssistantInstructorId(course.assistantInstructor?.id ?? "");
      setTrainingRoomId(course.trainingRoom?.id ?? "");
      setLink(course.link);
      setServeyEmailTemplateId(course.surveyEmailTemplateId);
      setComputerIds(course.computers.map(c => c.id));
      setCanceled(course.canceled);
      setDoNotPublish(course.doNotPublish);
      setIsTotalPrice(course.isTotalPrice);
      setPriceId(course.price?.id ?? '');
      setPriceInfo(course.priceInfo);
      setFirstName(course.courseContactPerson?.firstName ?? '');
      setLastName(course.courseContactPerson?.lastName ?? "");
      setMobile(course.courseContactPerson?.mobile ?? "");
      setEmail(course.courseContactPerson?.email ?? "");
      setCompany(course.courseContactPerson?.companyName ?? "");
      setEvaluationId(course.surveyid);
      setHtmlContentIngress(course.courseIngress);
      setHtmlContentDescription(course.courseDescription);
      setCourseRegistrationInfo(course.courseRegistrationInfo);
      setEmailTemplateHtml(emailTemplatesCourseConfirmation1.emailTemplateHtml);
    }
  }, [course, emailTemplatesCourseConfirmation1]);

  useEffect(() => {
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'numeric', year: 'numeric' };
    const formattedDate = date ? date.toLocaleDateString('no-NO', options).replace(/\./g, '-') : '';

    const trainingRoom = rooms.find(i => i.id === trainingRoomId);
    const link = trainingRoom?.name.split(' ').join('-');

    const trainingRoomSegment =
      (link && formattedDate) ? `${link}-` :
        (!link && formattedDate) ? `velg-sted-` :
          (link || '');

    setLink(trainingRoomSegment + '' + formattedDate)
  }, [trainingRoomId, date]);

  useEffect(() => {
    if (link && trainingRoomId && date) {
      makeCourseRequest(`idFromLink/${link}`, 'GET')
        .then((result: string) => {
          const id = result;
          if (id === link || id === "" || link === course.link) {
            setHelperText('OK');
          } else {
            setLink(link)
            setHelperText(`${t("baseCourse.duplicate")}`);
          }
        }).catch((error) => console.log('Error: ' + error));
    }
  }, [link]);
  useEffect(() => {
    if (date && endDate && trainingRoomId && instructorId && catalogId) {
      handleConflictCheck();
    }
  }, [date, course, instructorId, trainingRoomId, catalogId]);
  const handleConflictCheck = () => {
    if (date && endDate && trainingRoomId && instructorId && catalogId) {
      setIsCheckingConflict(true);
      const endTime = convertUnixTime(endDate.getTime() / 1000);
      const meetingRoom = rooms.find(r => r.id === trainingRoomId);
      const instructor = instructors.find(i => i.id === instructorId);
      const assistantInstructor = instructors.find(i => i.id === assistantInstructorId);
      if (endTime && date && meetingRoom && instructor) {
        const catalog = catalogs.find(c => c.id === catalogId);

        const body = {
          courseId: course.id,
          emails: [instructor.person.email, meetingRoom.email, assistantInstructor?.person.email],
          startTime: startOfDayAt7AM(date),
          endTime: endOfDayAt4PM(endDate),
          duration: catalog?.duration,
        }
        makeCourseRequest(`Course/Registrations/CheckCalendarEventConflicts`, 'POST', body).then((result: any) => {
          if (result.length > 0) {
            setIsCheckingConflict(false);
            setConflicts(result.map((d: any) => `${d.text} \n ${d.subject} `).join('\n \n'));
          }
          else {
            setIsCheckingConflict(false);
            setConflicts('');
          }
        });
      }
    }
  }

  useEffect(() => {
    if (course && date) {
      const initialDate = date;
      const endDate = new Date(initialDate);
      if (course.duration.unit === 'dag' || course.duration.unit === 'dager') {
        endDate.setDate(endDate.getDate() + (course.duration.value) - 1);
      }
      setEndDate(endDate);
    }
  }, [date, course]);

  const d = date ? new Date(date) : new Date();
  const trainingRoom = rooms.find(i => i.id === trainingRoomId);
  const selectedCourse = catalogs.find(c => c.id === catalogId);

  const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const formattedStartDate = date ? date.toLocaleDateString('no-NO', options) : '';
  const formattedEndDate = endDate ? endDate.toLocaleDateString('no-NO', options) : '';
  const durationValue = course?.duration?.value;
  const pluralSuffix = durationValue > 1 ? t("standard.days") : t("baseCourse.day");

  const handleProductChange = (computerId: string, checked: boolean) => {
    if (checked) setComputerIds([...computerIds, computerId]);
    else setComputerIds(computerIds.filter(id => id !== computerId));
  };

  const missingFields = (): boolean => {
    if (isTotalPrice && !priceId) {
      return true;
    }
    if (helperText === t("baseCourse.duplicate")) {
      return true;
    }

    const requiredFieldsFilled =
      catalogId &&
      date &&
      instructorId &&
      trainingRoomId &&
      surveyEmailTemplateId;
    return requiredFieldsFilled ? false : true;
  };

  const missingSendConfirmationFields = (): boolean => {
    const requiredFieldsFilled =
      !missingFields() &&
      firstName &&
      lastName &&
      email &&
      mobile &&
      company
    return requiredFieldsFilled ? false : true;
  };

  const handleUpdateCourse = () => {
    setLoading(true);
    if (!selectedCourse || !trainingRoom) {
      return;
    }
    const body = {
      id: course.id,
      dt: course.dt,
      _ts: course._ts,
      createdAt: course.createdAt,
      appointmentId: course.appointmentId,
      calendarEventId: course.calendarEventId,
      link: link,
      catalogId: catalogId,
      catalogLink: course.catalogLink,
      partNumber: course.partNumber,
      adskCourseId: adskCourseId,
      courseName: selectedCourse.courseName,
      courseIngress: htmlContentIngress,
      courseDescription: htmlContentDescription,
      courseRegistrationInfo: courseRegistrationInfo,
      level: selectedCourse.level,
      keywords: course.keywords,
      date: (d.getTime()) / 1000,
      duration: selectedCourse.duration,
      address: trainingRoom.address,
      postCode: trainingRoom.postCode,
      city: trainingRoom.city,
      price: isTotalPrice ? prices.find(p => p.id === priceId) : selectedCourse.price,
      instructor: instructors.find(i => i.id === instructorId),
      assistantInstructor: instructors.find(i => i.id === assistantInstructorId),
      trainingRoom: trainingRoom,
      computers: computers.filter(computer => computerIds?.includes(computer.id)),
      canceled: canceled,
      doNotPublish: doNotPublish,
      isTotalPrice: isTotalPrice,
      courseContactPerson: {
        firstName: firstName,
        lastName: lastName,
        email: email,
        mobile: mobile,
        companyName: company
      },
      priceInfo: priceInfo,
      surveyid: evaluationId,
      surveyEmailTemplateId: surveyEmailTemplateId
    }
    makeCourseRequest(`course/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t("baseCourse.updatedCourseInList"), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(ex => setSnackbarMessage({ content: "Kan ikke avlyse kurs som har påmeldte kursdeltagere", type: "error" }));
  };

  const handleSendExternalCourseConfirmation = () => {
    setLoading(true);
    if (!selectedCourse || !trainingRoom) {
      return;
    }
    const body = {
      course: {
        id: course.id,
        _ts: course._ts,
        createdAt: course.createdAt,
        appointmentId: course.appointmentId,
        link: link,
        catalogId: catalogId,
        catalogLink: course.catalogLink,
        partNumber: course.partNumber,
        adskCourseId: adskCourseId,
        courseName: selectedCourse.courseName,
        courseIngress: htmlContentIngress,
        courseDescription: htmlContentDescription,
        courseRegistrationInfo: courseRegistrationInfo,
        level: selectedCourse.level,
        keywords: course.keywords,
        date: (d.getTime()) / 1000,
        duration: selectedCourse.duration,
        address: trainingRoom.address,
        postCode: trainingRoom.postCode,
        city: trainingRoom.city,
        price: isTotalPrice ? prices.find(p => p.id === priceId) : selectedCourse.price,
        instructor: instructors.find(i => i.id === instructorId),
        assistantInstructor: instructors.find(i => i.id === assistantInstructorId),
        trainingRoom: rooms.find(r => r.id === trainingRoomId),
        computers: computers.filter(computer => computerIds?.includes(computer.id)),
        canceled: canceled,
        doNotPublish: doNotPublish,
        isTotalPrice: isTotalPrice,
        courseContactPerson: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          mobile: mobile,
          companyName: company
        },
        priceInfo: priceInfo,
        surveyid: evaluationId,
        surveyEmailTemplateId: surveyEmailTemplateId
      },
      template: emailTemplateHtml
    }
    makeCourseRequest(`course/sendExternalCourseConfirmation`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t("baseCourse.updatedCourseInListAndSentAnEmailToContactPerson"), type: "info", });
      setLoading(false);
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("baseCourse.couldNotUpdateCourseInList"), type: "error" }));
  }

  return (<>
    <Dialog
      open={props.open}
      maxWidth="xl"
      fullWidth>
      <DialogTitle className='mb-4'>
        <div dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={3}>
            <div className='mb-3'>
              <TextField
                label={t("standard.adskCourseId")}
                name='adskCourseId'
                fullWidth
                sx={{ minWidth: 300 }}
                value={adskCourseId || ''}
                onChange={handleAdskCourseIdChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <Autocomplete
                value={catalogId || ''}
                options={catalogs}
                getOptionLabel={(catalogId: any) => {
                  const catalog = catalogs.find(c => c.id === catalogId);
                  return catalog ? catalog?.courseName : `${t("baseCourse.unknownCourse")} (${catalogId})`;
                }}
                filterOptions={(options: ICatalog[], state: any) => {
                  return options.filter(option => option.courseName.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props: any, catalogId: ICatalog) => {
                  return (
                    <div onClick={(event) => handleCatalogIdChange(catalogId.id)}>
                      <MenuItem key={catalogId.id} value={catalogId.id}>
                        <ListItemText primary={catalogId.courseName} />
                      </MenuItem>
                    </div>
                  )
                }}
                renderInput={(params: any) => {
                  return <TextField
                    {...params}
                    fullWidth
                    label={<span>{t("standard.courseName")} &#42;</span>}
                    hiddenLabel
                  />
                }}
              />
            </div>
          </Col>
          <Col xl={6}>
            <div className='d-flex align-items-end mb-3'>
              <div className='me-1'>
                <DatePicker
                  label={<span>{t("standard.date")} &#42;</span>}
                  inputFormat="dd.MM.yyyy"
                  value={date || null}
                  onChange={handleDateChange}
                />
              </div>
              {isCheckingConflict ? (
                <div>
                  <Icon className="material-icons-outlined" color='info'>pending</Icon>
                </div>
              ) : (
                conflicts ? (
                  <div>
                    <IconButton onClick={toggleConflictOpen}>
                      <Icon className="material-icons-outlined" color='error'>info</Icon>
                    </IconButton>
                  </div>
                ) : (
                  <div>
                    <Icon className="material-icons-outlined" color='success'>check_circle</Icon>
                  </div>
                )
              )}
              <Typography
                component="div"
                variant='body6'
                className='ms-1 mb-2'>
                {`${formattedStartDate} - ${formattedEndDate} (${durationValue} ${pluralSuffix})`}
              </Typography>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <Autocomplete
                value={instructorId || ''}
                options={instructors}
                getOptionLabel={(instructorId: any) => {
                  const instructor = instructors.find(i => i.id === instructorId);
                  return instructor ? `${instructor?.person.firstName} ${instructor?.person.lastName}` : instructorId;
                }}
                filterOptions={(options: IInstructor[], state: any) => {
                  return options.filter(option => `${option.person.firstName} ${option.person.lastName}`.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props: any, instructorId: IInstructor) => {
                  return (
                    <div onClick={(event) => handleInstructorIdChange(instructorId.id)}>
                      <MenuItem key={instructorId.id} value={instructorId.id}>
                        <ListItemText primary={`${instructorId.person.firstName} ${instructorId.person.lastName}`} />
                      </MenuItem>
                    </div>
                  )
                }}
                renderInput={(params: any) => {
                  return <TextField
                    {...params}
                    fullWidth
                    label={<span>{t("standard.instructor")} &#42;</span>}
                    hiddenLabel
                  />
                }}
              />
            </div>
          </Col>
          <Col xl={6}>
            <div className='mb-3'>
              <Autocomplete
                value={assistantInstructorId || ''}
                options={instructors}
                getOptionLabel={(assistantInstructorId: any) => {
                  const instructor = instructors.find(i => i.id === assistantInstructorId);
                  return instructor ? `${instructor?.person.firstName} ${instructor?.person.lastName}` : assistantInstructorId;
                }}
                filterOptions={(options: IInstructor[], state: any) => {
                  return options.filter(option => `${option.person.firstName} ${option.person.lastName}`.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props: any, assistantInstructorId: IInstructor) => {
                  return (
                    <div onClick={(event) => handleAssistantInstructorIdChange(assistantInstructorId.id)}>
                      <MenuItem key={assistantInstructorId.id} value={assistantInstructorId.id}>
                        <ListItemText primary={`${assistantInstructorId.person.firstName} ${assistantInstructorId.person.lastName}`} />
                      </MenuItem>
                    </div>
                  )
                }}
                renderInput={(params: any) => {
                  return <TextField
                    {...params}
                    fullWidth
                    label={<span>{t("standard.assistantInstructor")}</span>}
                    hiddenLabel
                  />
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <Autocomplete
                value={trainingRoomId || ''}
                options={rooms}
                getOptionLabel={(trainingRoomId: any) => {
                  const room = rooms.find(r => r.id === trainingRoomId);
                  return room?.name || trainingRoomId;
                }}
                filterOptions={(options: IRoom[], state: any) => {
                  return options.filter(option => option.name.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props: any, trainingRoomId: IRoom) => {
                  return (
                    <div onClick={(event) => handleTrainingRoomIdChange(trainingRoomId.id)}>
                      <MenuItem key={trainingRoomId.id} value={trainingRoomId.id}>
                        <ListItemText primary={trainingRoomId.name} />
                      </MenuItem>
                    </div>
                  )
                }}
                renderInput={(params: any) => {
                  return <TextField
                    {...params}
                    fullWidth
                    label={<span>{t("standard.trainingRoom")} &#42;</span>}
                    hiddenLabel
                  />
                }}
              />
            </div>
          </Col>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={
                  <span>
                    {t("baseCourse.linkToCourse")}
                    <span style={{ color: helperText === t("baseCourse.duplicate") ? '#A30014' : '#2e7d32' }}>
                      {helperText && ` (${helperText})`}
                    </span>
                  </span>
                }
                name='link'
                fullWidth
                value={link || ''}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={2}>
            <div className='mb-3'>
              <TextField
                label={t("standard.maxNumberOfSeats")}
                name='link'
                fullWidth
                value={trainingRoom?.seats || ''}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={t("standard.address")}
                name='address'
                fullWidth
                sx={{ minWidth: 300 }}
                value={trainingRoom?.address || ''}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <Row>
              <Col xl={4}>
                <div className='mb-3'>
                  <TextField
                    label={t("standard.postCode")}
                    name='postCode'
                    fullWidth
                    value={trainingRoom?.postCode || ''}
                    disabled
                  />
                </div>
              </Col>
              <Col xl={8}>
                <div className='mb-3'>
                  <TextField
                    label={t("standard.place")}
                    fullWidth
                    name='place'
                    value={trainingRoom?.city || ''}
                    disabled
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='d-flex align-items-end flex-wrap mb-3'>
              <div className='me-3'>
                <Select
                  label={<span>{t("standard.evaluation")} &#42;</span>}
                  name='evaluation'
                  displayEmpty
                  fullWidth
                  value={evaluationId || ''}
                  onChange={handleEvaluationIdChange}
                  sx={{ minWidth: 300 }}>
                  <MenuItem value={''}>{t("standard.noEvaluation")}</MenuItem>
                  {surveyTypes.map((s) =>
                    <MenuItem key={s.id} value={s.id}>
                      {s.data.surveyinfo.title}
                    </MenuItem>
                  )}
                </Select>
              </div>
              <div>
                <Link
                  href="https://createSurvey.azurewebsites.net/"
                  target="_blank"
                  underline='always'
                  className='MuiTypography-body5'>
                  <div className='d-flex align-items-end'>
                    <Icon className='me-1'>open_in_new</Icon>{t("standard.addNewEvaluationForm")}
                  </div>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={3}>
            <div className='mb-3'>
              <Select
                label={<span>{t("standard.email")} &#42;</span>}
                name='serveyEmailTemplate'
                displayEmpty
                fullWidth
                sx={{ minWidth: 300 }}
                value={surveyEmailTemplateId || ''}
                onChange={handleServeyEmailTemplateIdChange}>
                {emailTemplatesSurveys.map(e => (
                  <MenuItem
                    key={e.id}
                    value={e.id}>
                    {e.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='mb-3'>
              <Autocomplete
                value={computerIds || []}
                multiple
                options={computers}
                getOptionLabel={(computerIds: any) => {
                  const computer = computers.find(ua => ua.id === computerIds);
                  return computer?.name || '';
                }}
                filterOptions={(options: IComputer[], state: any) => {
                  return options.filter(option => option.name.toLowerCase().includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props: any, computers: IComputer) => {
                  return (
                    <div onClick={(event) => handleProductChange(computers.id, !computerIds.includes(computers.id))}>
                      <MenuItem key={computers.id} value={computers.id}>
                        <Checkbox
                          checked={computerIds.includes(computers.id)}
                          onChange={(event: any, checked: boolean) => handleProductChange(computers.id, checked)}
                        />
                        <ListItemText primary={computers.name} />
                      </MenuItem>
                    </div>
                  )
                }}
                renderInput={(params: any) => {
                  return <TextField
                    {...params}
                    fullWidth
                    label={<span>{t("standard.selectComputerEquipment")} &#42;</span>}
                    hiddenLabel
                  />
                }}
                onChange={(event: any, computerIds: any) => setComputerIds(computerIds)}
              />
            </div>
          </Col>
        </Row>
        <div className='d-flex mb-3'>
          <CheckboxLabel
            label={t("baseCourse.cancelCourse")}
            checked={canceled || false}
            onChange={handleCanceled}
          />
        </div>
        <div className='d-flex mb-3'>
          <CheckboxLabel
            label={t("baseCourse.doNotPublishCourse")}
            checked={doNotPublish || false}
            onChange={handleDoNotPublish}
          />
        </div>
        <div className='d-flex mb-4'>
          <CheckboxLabel
            label={t("standard.courseWithTotalPrice")}
            checked={isTotalPrice || false}
            onChange={handleIsTotalPrice}
          />
        </div>
        <Row>
          <Col xl={3}>
            {isTotalPrice &&
              <div className='mb-3'>
                <Select
                  label={t("standard.selectPrice")}
                  name='selectPrice'
                  displayEmpty
                  fullWidth
                  sx={{ minWidth: 300 }}
                  onChange={handlePriceIdChange}
                  value={priceId || ''}>
                  {prices.map(p => (
                    <MenuItem
                      key={p.id}
                      value={p.id}>
                      {p.value}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            }
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            {isTotalPrice &&
              <div className='mb-3'>
                <TextField
                  label={t("standard.priceInformation")}
                  name='priceInformation'
                  fullWidth
                  sx={{ minWidth: 300 }}
                  value={priceInfo || ''}
                  onChange={handlePriceInfoChange}
                />
              </div>
            }
          </Col>
        </Row>
        <div className='mb-3'>
          <Link
            href={`http://kurs.focus.no/kurs/info/${link}`}
            className='MuiTypography-body5'
            underline='always'
            target="_blank">
            <div className='d-flex align-items-end'>
              <Icon className='me-1'>open_in_new</Icon>{t("baseCourse.goToCourse")}
            </div>
          </Link>
        </div>

        <Divider>
          <Chip label={t("baseCourse.registrant")} size="small" />
        </Divider>
        <Row>
          <Col xl={4}>
            <div className='mb-3'>
              <TextField
                label={<span>{t("standard.firstName")} &#42;</span>}
                name='firstName'
                fullWidth
                sx={{ minWidth: 300 }}
                value={firstName || ''}
                onChange={handleFirstNameChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={4}>
            <div className='mb-3'>
              <TextField
                label={<span>{t("standard.lastName")} &#42;</span>}
                name='lastName'
                fullWidth
                sx={{ minWidth: 300 }}
                value={lastName || ''}
                onChange={handleLastNameChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={2}>
            <div className='mb-3'>
              <TextField
                label={<span>{t("standard.mobileNo")} &#42;</span>}
                name='phone'
                fullWidth
                sx={{ minWidth: 200 }}
                value={mobile || ''}
                onChange={handleMobileChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={<span>{t("standard.email")} &#42;</span>}
                name='emailRegistrant'
                fullWidth
                sx={{ minWidth: 300 }}
                value={email || ''}
                onChange={handleEmailChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={<span>{t("standard.company")} &#42;</span>}
                name='companyRegistrant'
                fullWidth
                sx={{ minWidth: 300 }}
                value={company || ''}
                onChange={handleCompanyChange}
              />
            </div>
          </Col>
        </Row>
        <div className='mb-3'>
          <Accordion>
            <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
              {t("baseCourse.courseConfirmationEmailTemplate")}
            </AccordionSummary>
            <AccordionDetails>
              <div className='mb-3'>
                <label className='mb-1'>{t("baseCourse.template")}</label>
                <Froala
                  maxHeight={800}
                  model={emailTemplateHtml || ''}
                  onModelChanged={setEmailTemplateHtml}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='mb-5'>
          <LoadingButton
            variant="contained"
            color='secondary'
            onClick={handleSendExternalCourseConfirmation}
            disabled={loading || missingSendConfirmationFields()}
            loading={loading}
            className='minButtonWidth'>
            {loading ? '' : t("baseCourse.sendConfirmation")}
          </LoadingButton>
        </div>
        <div className='mb-3'>
          <label className='mb-1'>{t("baseCourse.preamble")}</label>
          <Froala
            maxHeight={800}
            model={htmlContentIngress}
            onModelChanged={setHtmlContentIngress}
          />
        </div>
        <div className='mb-3'>
          <label className='mb-1'>{t("standard.description")}</label>
          <Froala
            maxHeight={800}
            model={htmlContentDescription || ''}
            onModelChanged={setHtmlContentDescription}
          />
        </div>
        <div className='mb-3'>
          <MultiLineTextField
            fullWidth
            label={t("standard.additionalInformationForParticipantUponConfirmationOfRegistration")}
            name='additionalInformation'
            minRows={1}
            value={courseRegistrationInfo || ""}
            onChange={handleCourseRegistrationInfoChange}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleUpdateCourse}
          disabled={loading || missingFields() || props.course.canceled}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : props.handleOkText}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>

    {isConflictOpen && <ConflictCheckDiaryDialog
      onClose={toggleConflictOpen}
      open={!!isConflictOpen}
      conflicts={conflicts}
    />}
  </>);
}

export default BaseCourseDialog;
